module.exports = __webpack_public_path__ + "media/images/badges/google_badge-d0517ff4d13771d89535e82bcf8f6c96.svg";